/**
 * Variant to define styling of EnButton.
 */
export const EnButtonVariants = Object.freeze({
    NORMAL: 'normal',
    FILLED: 'filled',
    TEXT: 'text',
});
